import styled from 'styled-components';
export const Wrapper = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 15px 0;
  margin: auto;
`;
export const Title = styled.p `
  font-size: 16px;
  margin-bottom: 15px;
`;
